import { ATTACHMENT_BOUNDARY_PATH_PREFIX } from "../../common/constants";

export const DASHBOARD_ROUTE_PREFIX = "/";
export const DASHBOARD_NOTICE_ROUTE_PREFIX = DASHBOARD_ROUTE_PREFIX + "dashboard-notices";

export const DASHBOARD_ROUTE_PATHS = {
  homepage: { path: "*", to: DASHBOARD_ROUTE_PREFIX },
  noticeAttachment: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}${DASHBOARD_NOTICE_ROUTE_PREFIX}/:id1/attachments/:id2` }
};
